import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';

import { space } from 'style/config';

import { Text } from 'components/ui';
import Avatar from 'components/Avatar';

const SEOAccountMenu = ({ localization }) => {
    return (
        <a
            href='/account/signin'
            css={styles.seoLink}
            data-at={Sephora.debug.dataAt('seo_sign_in_link')}
        >
            <Avatar
                src='/img/ufe/icons/me32.svg'
                marginY={-1}
                marginRight={3}
                size={32}
                style={styles.avatar}
            />
            <span>
                <Text
                    fontSize='sm'
                    fontWeight='bold'
                    display='block'
                >
                    {localization.signIn}
                </Text>
                <Text
                    fontSize='xs'
                    display='block'
                >
                    {localization.signInPrompt}
                </Text>
            </span>
        </a>
    );
};

SEOAccountMenu.propTypes = {
    localization: PropTypes.shape({
        signIn: PropTypes.string.isRequired,
        signInPrompt: PropTypes.string.isRequired
    }).isRequired
};

const styles = {
    seoLink: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: space[4],
        paddingRight: space[4],
        lineHeight: 'tight',
        height: '100%',
        minWidth: '13em',
        textDecoration: 'none',
        color: 'inherit'
    },
    avatar: {
        opacity: 0.6
    }
};

export default wrapFunctionalComponent(SEOAccountMenu, 'SEOAccountMenu');
